import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { compact } from 'lodash-es';
import { getTestIds } from '../../utils/TestIds';
import { useSheetStack } from '../OverlayContext/useSheetStack';
import { MobileSummaryCard } from '../TextField';
import { MobileTextFieldTID } from '../TextField/BaseTextField/BaseTextField.utils';
import { Typography } from '../Typography';
import { buildAutocompleteBottomSheet, buildErrorInfoSuffix, deriveAutocompleteDisplayValue, shouldShowHelperText } from './Autocomplete.utils';
export const GetMobileAutocompleteCardTID = (parentTestId)=>getTestIds(parentTestId);
export function MobileAutocompleteCard(_0) {
    let { textFieldProps, loading, noOptionsText, error, helperText, errorInfo, disabled, popoverFooter, searchBiName, fullHeightSheet = true, extraCardItems, hideRemoveAction } = _0, props = _object_without_properties(_0, [
        "textFieldProps",
        "loading",
        "noOptionsText",
        "error",
        "helperText",
        "errorInfo",
        "disabled",
        "popoverFooter",
        "searchBiName",
        "fullHeightSheet",
        "extraCardItems",
        "hideRemoveAction"
    ]);
    const { pushBottomSheetPage } = useSheetStack();
    const { MobileAutocompleteCardTestIds } = useMemo(()=>GetMobileAutocompleteCardTID(props.testId), [
        props.testId
    ]);
    const displayValue = deriveAutocompleteDisplayValue(props);
    const hasValue = !!displayValue;
    const handleRemove = ()=>{
        var _props_onChange;
        const clearValue = props.multiple ? [] : null;
        (_props_onChange = props.onChange) === null || _props_onChange === void 0 ? void 0 : _props_onChange.call(props, {}, clearValue, 'clear', undefined);
    };
    const openBottomSheet = ()=>{
        pushBottomSheetPage({
            fullHeight: fullHeightSheet,
            content: buildAutocompleteBottomSheet(_object_spread_props(_object_spread({}, props), {
                loading,
                noOptionsText,
                label: textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.label,
                popoverFooter,
                searchBiName
            }))
        });
    };
    return /*#__PURE__*/ _jsx(MobileSummaryCard, {
        testId: props.testId,
        items: [
            {
                title: textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.label,
                titleTestId: MobileTextFieldTID.Label(props.testId),
                body: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            ellipsis: true,
                            testId: MobileTextFieldTID.Value(props.testId),
                            skin: error ? 'error' : 'standard',
                            children: displayValue
                        }),
                        buildErrorInfoSuffix({
                            error,
                            errorInfo,
                            testId: props.testId
                        }),
                        helperText && shouldShowHelperText({
                            error,
                            errorInfo
                        }) && /*#__PURE__*/ _jsx(Typography, {
                            testId: MobileTextFieldTID.HelperText(props.testId),
                            skin: error ? 'error' : 'secondary',
                            children: helperText
                        })
                    ]
                }),
                actions: compact([
                    hasValue && !props.disableClearable && !disabled && !hideRemoveAction && {
                        type: 'remove',
                        testId: MobileTextFieldTID.RemoveButton(props.testId),
                        onClick: handleRemove,
                        // WHY: inherent fixed-semantic clear; consumers cannot rename it (rule 6a), and the parent's select-only handleChange does not log the 'clear' reason, so this is not a double-fire.
                        bi: {
                            name: 'remove'
                        }
                    },
                    !disabled && {
                        type: 'edit',
                        testId: MobileTextFieldTID.EditButton(props.testId),
                        onClick: openBottomSheet,
                        // WHY: inherent action opening the option bottom-sheet; consumers cannot rename it (rule 6a) and it dispatches no onChange, so it cannot double-fire.
                        bi: {
                            name: 'edit'
                        }
                    }
                ])
            },
            ...(extraCardItems !== null && extraCardItems !== void 0 ? extraCardItems : []).map((item, index)=>_object_spread({
                    bodyTestId: props.testId ? MobileAutocompleteCardTestIds.ExtraItem(index) : undefined,
                    disableEllipsis: true
                }, item))
        ]
    });
}
